import type { ReactNode } from 'react'

import { Skeleton } from '@/components/ui/skeleton'

/**
 * Loading skeleton placeholder for the connectors list view.
 */
export const ConnectorListSkeleton: React.FC = (): ReactNode => (
  <div className="connectors-list-view space-y-4">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <Skeleton className="h-40 rounded-lg" />
      <Skeleton className="h-40 rounded-lg" />
    </div>
  </div>
)

ConnectorListSkeleton.displayName = 'ConnectorListSkeleton'
